<app-navbar></app-navbar>
<div class="container py-5">
  <h2 style="margin-bottom: 25px;">{{ 'COURSE_PAGE.TITLE' | translate }}</h2>
  <div class="row">
    <div class="col-md-12">
      <mat-card [appearance]="'outlined'">
        <mat-card-content>
          <h4>{{ 'COURSE_PAGE.OBJECTIVES.TITLE' | translate }}</h4>
          <p>
            <strong>{{ 'COURSE_PAGE.INTRO.PARAGRAPH1_START' | translate }}</strong>
             {{ 'COURSE_PAGE.INTRO.PARAGRAPH1_START_1' | translate }} 
             <strong>{{ 'COURSE_PAGE.INTRO.PARAGRAPH1_START_2' | translate }}</strong>
            {{ 'COURSE_PAGE.INTRO.PARAGRAPH1' | translate }}
          </p>

          <p>
            {{ 'COURSE_PAGE.INTRO.PARAGRAPH2' | translate }}
          </p>
          <ul>
            <li><strong>{{ 'COURSE_PAGE.OBJECTIVES.ITEM1_TITLE' | translate }}</strong> {{ 'COURSE_PAGE.OBJECTIVES.ITEM1' | translate }}</li>
            <li><strong>{{ 'COURSE_PAGE.OBJECTIVES.ITEM2_TITLE' | translate }}</strong> {{ 'COURSE_PAGE.OBJECTIVES.ITEM2' | translate }}</li>
            <li><strong>{{ 'COURSE_PAGE.OBJECTIVES.ITEM3_TITLE' | translate }}</strong> {{ 'COURSE_PAGE.OBJECTIVES.ITEM3' | translate }}</li>
            <li><strong>{{ 'COURSE_PAGE.OBJECTIVES.ITEM4_TITLE' | translate }}</strong> {{ 'COURSE_PAGE.OBJECTIVES.ITEM4' | translate }}</li>
          </ul>

          <h5>{{ 'COURSE_PAGE.EDUCATION.TITLE' | translate }}</h5>
          <p>
            {{ 'COURSE_PAGE.EDUCATION.TITLE_DESCRIPTION' | translate }}
          </p>
          <ul>
            <li>{{ 'COURSE_PAGE.EDUCATION.ITEM1' | translate }}</li>
            <li>{{ 'COURSE_PAGE.EDUCATION.ITEM2' | translate }}</li>
            <li> 
              {{ 'COURSE_PAGE.EDUCATION.ITEM3_START' | translate }}
              <strong>{{ 'COURSE_PAGE.EDUCATION.ITEM3' | translate }}</strong>
              {{ 'COURSE_PAGE.EDUCATION.ITEM3_END' | translate }}
            </li>
          </ul>

          <h5>{{ 'COURSE_PAGE.EXPERIENCE.TITLE' | translate }}</h5>
           <p>
            {{ 'COURSE_PAGE.EXPERIENCE.TITLE_DESCRIPTION' | translate }}
          </p>
          <ul>
            <li><strong>{{ 'COURSE_PAGE.EXPERIENCE.ITEM1_START' | translate }}</strong> {{ 'COURSE_PAGE.EXPERIENCE.ITEM1' | translate }}</li>
            <li><strong>{{ 'COURSE_PAGE.EXPERIENCE.ITEM2_START' | translate }}</strong> {{ 'COURSE_PAGE.EXPERIENCE.ITEM2' | translate }}</li>
            <li><strong>{{ 'COURSE_PAGE.EXPERIENCE.ITEM3_START' | translate }}</strong> {{ 'COURSE_PAGE.EXPERIENCE.ITEM3' | translate }}</li>
            <li><strong>{{ 'COURSE_PAGE.EXPERIENCE.ITEM4_START' | translate }}</strong> {{ 'COURSE_PAGE.EXPERIENCE.ITEM4' | translate }}</li>
          </ul>
           <p>
            {{ 'COURSE_PAGE.EXPERIENCE.TITLE_SUMMARY' | translate }}
          </p>

          <h5>{{ 'COURSE_PAGE.PROFESSIONAL_ASSOCIATIONS.TITLE' | translate }}</h5>
          <p>
            {{ 'COURSE_PAGE.PROFESSIONAL_ASSOCIATIONS.TITLE_DESCRIPTION' | translate }}
          </p>
          <ul>
            <li><strong>{{ 'COURSE_PAGE.PROFESSIONAL_ASSOCIATIONS.ITEM1_TITLE' | translate }}</strong> {{ 'COURSE_PAGE.PROFESSIONAL_ASSOCIATIONS.ITEM1' | translate }}</li>
            <li><strong>{{ 'COURSE_PAGE.PROFESSIONAL_ASSOCIATIONS.ITEM2_TITLE' | translate }}</strong> {{ 'COURSE_PAGE.PROFESSIONAL_ASSOCIATIONS.ITEM2' | translate }}</li>
            <li><strong>{{ 'COURSE_PAGE.PROFESSIONAL_ASSOCIATIONS.ITEM3_TITLE' | translate }}</strong> {{ 'COURSE_PAGE.PROFESSIONAL_ASSOCIATIONS.ITEM3' | translate }}</li>
          </ul>

          <p><strong>{{ 'COURSE_PAGE.PROFESSIONAL_ASSOCIATIONS.TITLE_SUMMARY' | translate }}</strong></p>
          <ul>
            <li>{{ 'COURSE_PAGE.PROFESSIONAL_ASSOCIATIONS.SUMMARY_ITEM1' | translate }}</li>
            <li>{{ 'COURSE_PAGE.PROFESSIONAL_ASSOCIATIONS.SUMMARY_ITEM2' | translate }}</li>
            <li>{{ 'COURSE_PAGE.PROFESSIONAL_ASSOCIATIONS.SUMMARY_ITEM3' | translate }}</li>
            <li>{{ 'COURSE_PAGE.PROFESSIONAL_ASSOCIATIONS.SUMMARY_ITEM4' | translate }}</li>
          </ul>

          <h4>{{ 'COURSE_PAGE.IMPACT.TITLE' | translate }}</h4>
          <p>
            {{ 'COURSE_PAGE.IMPACT.PARAGRAPH1' | translate }} <strong>{{ 'COURSE_PAGE.IMPACT.PARAGRAPH1_END' | translate }}</strong>
          </p>
          <p>
            {{ 'COURSE_PAGE.IMPACT.PARAGRAPH2_START' | translate }} <strong>{{ 'COURSE_PAGE.IMPACT.PARAGRAPH2' | translate }}</strong> {{ 'COURSE_PAGE.IMPACT.PARAGRAPH2_END' | translate }}
          </p>


          <h4>{{ 'COURSE_PAGE.RESULTS.TITLE' | translate }}</h4>
          <ul>
            <li><strong>{{ 'COURSE_PAGE.RESULTS.ITEM1_START' | translate }}</strong> {{ 'COURSE_PAGE.RESULTS.ITEM1' | translate }}</li>
            <li><strong>{{ 'COURSE_PAGE.RESULTS.ITEM2_START' | translate }}</strong> {{ 'COURSE_PAGE.RESULTS.ITEM2' | translate }}</li>
            <li><strong>{{ 'COURSE_PAGE.RESULTS.ITEM3_START' | translate }}</strong> {{ 'COURSE_PAGE.RESULTS.ITEM3' | translate }}</li>
            <li><strong>{{ 'COURSE_PAGE.RESULTS.ITEM4_START' | translate }}</strong> {{ 'COURSE_PAGE.RESULTS.ITEM4' | translate }}</li>
            <li><strong>{{ 'COURSE_PAGE.RESULTS.ITEM5_START' | translate }}</strong> {{ 'COURSE_PAGE.RESULTS.ITEM5' | translate }}</li>
            <li><strong>{{ 'COURSE_PAGE.RESULTS.ITEM6_START' | translate }}</strong> {{ 'COURSE_PAGE.RESULTS.ITEM6' | translate }}</li>
          </ul>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
<app-footer></app-footer>